<template>
  <div>
    <div class="header">
      <h5 class="title">证书查询</h5>
    </div>
    <div class="search-wrapper container">
      <a-alert
        :message="alertMessage"
        :type="alertType"
        style="max-width: 350px; margin: auto"
      ></a-alert>
      <br />
      <a-row type="flex" :gutter="40" align="middle" justify="center">
        <a-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
          <a-input
            size="large"
            addon-before="真实姓名"
            id="cert-name"
            placeholder="请输入姓名"
            v-model="queryParam.realname"
          />
          <a-input
            size="large"
            addon-before="身份证号"
            id="cert-idcard"
            placeholder="请输入身份证号"
            v-model="queryParam.idcard"
          />
        </a-col>
        <!-- <a-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
          <a-input
            size="large"
            addon-before="证书编号"
            id="cert-code"
            placeholder="请输入证书编号"
            v-model="queryParam.awardCode"
          />
        </a-col> -->
        <a-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
          <a-button style="height:50px;" type="primary" @click="onSearch()">查询</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="cert-wrapper" v-for="(item, index) in awardInfoList" :key="index">
      <a-divider>{{filterEventName(item.eventName)}}</a-divider>
      <div>
        <a-row>
          <!-- <a-col :span="24">
            <h3>{{filterEventName(item.eventName)}}</h3>
          </a-col> -->
          <a-col :span="6">
            <a-tag color="blue">
            项目：{{filterEventName(item.eventParentCategory)}}
            </a-tag>
          </a-col>
          <a-col :span="6">
            <a-tag color="blue">
            级别：{{filterEventName(item.eventCategory)}}
            </a-tag>
          </a-col>
          <a-col :span="6">
            <a-tag color="blue">
            成绩：{{item.canQueryScore?item.scoreResult:'未开放查询'}}
            </a-tag>
          </a-col>
          <a-col :span="6" v-if="item.canQueryCert && item.awardGrant && (item.awardGrant.sendStatus!=0 || item.awardGrant.lossStatus!=0)">
            <a-tag color="red" v-if="item.awardGrant.lossStatus==1">已申请补发</a-tag>
            <a-tag color="red" v-if="item.awardGrant.sendStatus==1">已申请寄送</a-tag>
            <a-tag color="red" v-if="item.awardGrant.lossStatus==-1">补发审核失败</a-tag>
            <a-tag color="red" v-if="item.awardGrant.sendStatus==-1">寄送审核失败</a-tag>
            <a-tag color="red" v-if="item.awardGrant.sendStatus==2||item.awardGrant.lossStatus==2">审核通过待寄送</a-tag>
            <a-tag color="red" v-if="item.awardGrant.sendStatus==3||item.awardGrant.lossStatus==3">已寄送</a-tag>
          </a-col>
        </a-row>
        <a-divider></a-divider>
        <h2 v-if="!item.canQueryCert">证书未开放查询</h2>
        <div v-if="item.canQueryCert && item.awardGrant==null">
          <h2 >未查询到证书</h2>
          <p v-if="item.canReviewCert">若您未查到本期测评的评定证书，可以点击“成绩复核”，了解情况。 </p>
        </div>
        <div class="cert" style="position: relative;">
          <!-- 修改的照片预览 -->
          <img
            :id="'cert-img-'+index"
            @load="calcPhotoPos(item,index)"
            v-if="item.awardGrant"
            :src="item.awardGrant.awardFile + '?t=' + new Date().getTime()"
            alt=""
          />
          <img v-if="item.awardGrant && userModifyApply.photo_url" :id="'modify-photo-'+item.awardGrant.id" :src="userModifyApply.photo_url" width="0" height="0" style="position: absolute;">
        </div>
        
        <div>
          <a-button v-if="item.awardGrant" class="cert-btn" type="danger" v-down="item.awardGrant.awardFile + '?t=' + new Date().getTime()"
            >电子版下载</a-button
          >
          <a-button v-if="item.awardGrant" class="cert-btn" :type="item.awardGrant.awardEnsure<=0?'danger':'default'" @click="ensure(item.awardGrant)"
            >证书确认</a-button
          >
          <a-button v-if="item.awardGrant" class="cert-btn" :type="item.awardGrant.awardEnsure<=0?'danger':'default'" @click="modify(item.awardGrant)"
            >信息更正</a-button
          >
          <a-button v-if="item.awardGrant && item.canSendCert" class="cert-btn" :type="item.awardGrant.awardEnsure<=0?'danger':'default'" @click="send(item.awardGrant)"
            >证书寄送</a-button
          >
          <a-button v-if="item.awardGrant" class="cert-btn" type="danger" @click="lost(item.awardGrant)"
            >挂失补寄</a-button
          >
          <a-button v-if="item.canQueryScoreReport" type="danger" class="cert-btn" @click="handleScoreReport(item)"
            >评价报告</a-button
          >
           <a-button v-if="item.canQueryScore && item.canReviewCert" :type="item.scoreResult=='再接再厉'?'danger':'default'" class="cert-btn" @click="handleRejudge(item)"
            >成绩复核</a-button
          >
          
        </div>
      </div>
      
    </div>
    <div>
      <img
        src="/cert/qrcode.jpg"
        style="width: 200px; height: 200px; display: block; margin: 30px auto"
        alt=""
      />
      <h4 style="text-align: center; font-size: 18px">
        青少年人工智能核心素养测评公众号
      </h4>
    </div>
    <EventPay ref="payModal" @payOk="payOk" />
    <a-modal title="证书寄送" v-model="sendModalVisible" @ok="handleSend" :width="800">
      <a-row type="flex" justify="space-between">
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <h2>寄送信息</h2>
          <!-- <a-textarea rows="10" v-model="sendAddress"> </a-textarea> -->
          <a-form :form="addressForm" :layout="_isMobile() ? 'vertical' : 'horizontal'">
            <a-form-item label="姓名">
              <a-input v-decorator="['name', {rules: [{ required: true, message: '请输入收件人姓名!' }]}]"></a-input>
            </a-form-item>
            <a-form-item label="电话">
              <a-input v-decorator="['phone',{
                  rules: [
                    {
                      required: true,
                      message: '请输入手机号!',
                      pattern: /^1[3456789]\d{9}$/,
                    }]}]"
              ></a-input>
            </a-form-item>
            <a-form-item label="寄送地址">
              <j-area-linkage :type="_isMobile()?'select':'cascader'"  v-decorator="['address', {rules: [{ required: true, message: '请请选择省市区!' }]}]" placeholder="请选择省市区" />
              <a-input v-decorator="['sendAddress', {rules: [{ required: true, message: '请输入收件人详细地址!' }]}]" placeholder="请输入详细地址"></a-input>
            </a-form-item>
            <a-form-item label="备注">
              <a-textarea rows="3"  v-decorator="['comment']"> </a-textarea>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
          <h2>提示信息</h2>
          <h3>快递费用：到付</h3>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal
      title="挂失补寄"
      v-model="lossModalVisible"
      @ok="handleLoss"
      :width="600"
    >
      <a-row type="flex" justify="space-between">
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <h2>寄送信息</h2>
          <a-textarea rows="10" v-model="sendAddress"> </a-textarea>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal title="评价报告" v-model="scoreReportModalVisible" :width="700" :footer="null">
    </a-modal>
    <a-modal title="成绩复核" v-model="rejudgeModalVisible" :width="700" :footer="null">
        <div v-if="currentItem">
          <p>
            <span>姓名：{{currentItem.realname}}</span>
            <a-divider type="vertical"></a-divider>
            <span>测评时间：{{currentItem.submitTime}}</span>
            <a-divider type="vertical"></a-divider>
            <span>项目：{{filterEventName(currentItem.eventParentCategory)}}</span>
            <a-divider type="vertical"></a-divider>
            <span>级别：{{filterEventName(currentItem.eventCategory)}}</span>
          </p>
          <h3>您的测评结果如下：</h3>
          <table class="table">
            <thead>
              <tr>
                <th>题目</th>
                <!-- <th>成绩</th> -->
                <th>评定结果</th>
              </tr>
            </thead>
            <tbody id="score-data">
              <tr>
                <td>综合理论(客观题)</td>
                <!-- <td>{{currentItem.objectiveScore}}</td> -->
                <td>{{currentItem.objectiveScoreResult=='再接再厉'?'未达到评定分数线':'合格'}}</td>
              </tr>
              <tr>
                <td>应用实践(实操题)</td>
                <!-- <td>{{currentItem.codeScore}}</td> -->
                <td>{{currentItem.codeScoreResult=='再接再厉'?'未达到评定分数线':'合格'}}</td>
              </tr>
            </tbody>
          </table>
          <a-divider></a-divider>
          <a-row v-if="scoreReport">
            <a-col :span="12" v-if="!isNoneObj(scoreReport.codeAnswerStudentList)">
              <h3>实操题学生答案：</h3>
              <span v-for="(val, key, index) in scoreReport.codeAnswerStudentList"  :key="index">
                <a v-down="val">{{index+1}}、{{key}}</a>
                <br>
              </span>
            </a-col>
            <a-col :span="12" v-if="!isNoneObj(scoreReport.codeAnswerList)">
              <h3>实操题参考答案：</h3>
              <span v-for="(val, key, index) in scoreReport.codeAnswerList"  :key="index">
                <a v-down="val">{{index+1}}、{{key}}</a>
                <br>
              </span>
            </a-col>
          </a-row>
          <br>
          <p>*本期成绩报告仅说明该生对本项目级别考核内容的掌握情况。</p>
        </div>
        <a-divider></a-divider>
        <div>
          <p>人工复核请填写邮箱地址，5个工作日内回复复核结果</p>
          <a-input style="width:200px" v-model="rejudgeEmail" placeholder="请填写邮箱"></a-input>
          <a-divider type="vertical"></a-divider>
          <a-button style="width:90px" type="danger" @click="rejudgeEmailSubmit">申请复核</a-button>
        </div>
        <!--<div>
          <div v-if="rejudgePayOk">
            <h2>支付成功后请扫码添加老师微信</h2>
            <img
                src="../assets/weixin.png"
                style="width: 400px;display: block;margin: 10px auto;"
              />
          </div>
          <div>
            <h3>您若申请专家人工介入复核，需扫码支付服务费50元，支付成功后，添加微信二维码，发送支付截图。5个工作内将回复复核结果。</h3>
          </div>
          <a-button @click="rejudge" type="danger">专家复议</a-button>
        </div> -->
    </a-modal>
    <VerifyCodeModal ref="verifyCodeModal"/>
  </div>
</template>

<script>
import { getAction, postAction } from "@/api/manage";
import QrCode from "@/components/tools/QrCode";
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import Area from '@/components/_util/Area'
// import JGraphicCode from '@/components/jeecg/JGraphicCode'
import VerifyCodeModal from '@/components/common/VerifyCodeModal'
import { jumpMixins } from "@/utils/jumpMixins";
import { mixinDevice } from '@/utils/mixin.js'
import pick from "lodash.pick";
export default {
  name: "CertQuery",
  mixins: [mixinDevice,jumpMixins],
  components: {
    QrCode,
    VerifyCodeModal,
    JAreaLinkage
    // JGraphicCode
  },
  data() {
    return {
      awardInfoList: [],
      alertMessage: "请输入姓名+身份证查询证书。",
      alertType: "success",
      queryParam: {
        awardCode: "",
        realname: "",
        idcard: "",
        // realname: "梁滋凌",
        // idcard: "469024201207226425",
        // realname: "闫勇涛",
        // idcard: "650105201104150011",
        //  realname: "夏雨涵",
        // idcard: "510182201604020223",
      },
      sendModalVisible: false,
      lossModalVisible: false,
      rejudgeModalVisible: false,
      scoreReportModalVisible: false,
      jsliderOk: false,
      rejudgePayOk: false,
      currentAwardGrant: null,
      currentItem: null,
      addressForm: this.$form.createForm(this),
      sendAddress: "收件人:\n\n手机号:\n\n地址:\n\n备注:\n",
      sendAddressInfo: {
        area: '',
        address: '',
        name: '',
        phone: '',
        comment: ''
      },
      scoreReport: {},
      rejudgeEmail: '',
      userModifyApply: {},
      areaData:''
      // verifiedCode: '',
      // verifiedCodeInput: '',
      // verifiedOk: false,
    };
  },
  created() {
    let id = this.$route.query.id;
    let awardCode = this.$route.query.code;
    this.queryParam.awardCode = awardCode;
    if (id || awardCode) {
      this.getAwardInfo(id, awardCode, null, null);
    }
    if (window.location.pathname == "/cert/query") {
      //window.location.href = "https://aice.org.cn/teaching/cert/query.html" + window.location.search
    }
    this.getMyModifyApply()
    this.initAreaData();
    console.log(this.$store.getters.userInfo);
  },
  mounted(){
  },
  methods: {
    initAreaData(){
      if(!this.areaData){
        this.areaData = new Area();
      }
    },
    onSearch() {
      let that = this
      this.$refs.verifyCodeModal.show(function(){
        that.getAwardInfo(
          null,
          that.queryParam.awardCode,
          that.queryParam.realname,
          that.queryParam.idcard
        );
      })
    },
    getAwardInfo(eventApplyId, awardCode, name, idcard) {
      if (!eventApplyId && !awardCode && !name && !idcard) {
        this.$message.info("请输入查询条件");
        return;
      }
      this.awardInfoList = []
      this.awardInfo = {};
      getAction("/teaching/teachingEventApply/queryCertAndScore", {
        eventApplyId: eventApplyId,
        awardCode: awardCode,
        name: name,
        idcard: idcard,
      }).then((res) => {
        if (res.success) {
          this.awardInfoList = res.result
          // for(let i=0;i<res.result.length;i++){
          //   this.calcPhotoPos(res.result[i].awardVars);
          // }
          this.alertMessage = `共查询到${this.awardInfoList.length}个测评记录，可点击证书下载。`;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getScoreReport(id){
      getAction("/teaching/teachingEventApply/queryCertScoreReport",{userPaperId: id}).then(res=>{
        if(res.success){
          this.scoreReport = res.result
        }
      })
    },
    filterEventName(eventName){
      if(!eventName){return ''}
      return eventName.replaceAll(" ", "").replace(/\(.*?\)/g,'').replace(/（.*?）/g,'')
    },
    isNoneObj(obj){
      return !obj || Object.keys(obj).length == 0
    },
    ensure(awardGrant) {
      if(this.isEnsure(awardGrant)){
        return
      }
      let that = this;
      if(!awardGrant.sendAddress){
        this.$info({
          title: "提示",
          content: "请先完成寄送地址填写",
        });
        return
      }
      this.$confirm({
        title: "证书确认",
        content: <h2>请确认证书信息是否正确？</h2>,
        onOk() {
          getAction("/teaching/teachingAwardGrant/ensureAward", {
            id: awardGrant.id,
            ensure: 1,
          })
            .then((res) => {
              that.$info({
                title: "提示",
                content: res.message,
              });
            })
            .catch((e) => {
              that.checkIsLogin(e);
            });
        },
        onCancel() {
          getAction("/teaching/teachingAwardGrant/ensureAward", {
            id: awardGrant.id,
            ensure: -1,
          })
            .then((res) => {
              that.$info({
                title: "提示",
                content: "请点击信息更新按钮申请修改证书",
              });
            })
            .catch((e) => {
              that.checkIsLogin(e);
            });
        },
        okText: "正确",
        cancelText: "不正确",
      });
    },
    modify(awardGrant) {
      if(this.isEnsure(awardGrant)){
        return
      }
      window.open("/user/info?awardId="+awardGrant.id)
    },
    getMyModifyApply(){
      getAction("/sys/sysUserModify/myModifyApply").then((res) => {
        if(res.success && res.result && res.result.length>0){
          this.userModifyApply = res.result[0]
        }
      })
      .catch((e) => {
        // that.checkIsLogin(e);
      });;
    },
    calcPhotoPos(award,index){
      if(!award.awardVars || !award.awardGrant){return;}
      let cert = document.getElementById("cert-img-"+index);
      let photo = document.getElementById("modify-photo-"+award.awardGrant.id);
      if(!cert || !photo){return}
      let scale = cert.width/cert.naturalWidth
      let awardVarsJson = JSON.parse(award.awardVars);
      for(let i=0; i<awardVarsJson.length;i++){
        let varItem = awardVarsJson[i]
        if(varItem.type == 'img' && varItem.varName == '照片'){
          photo.width = varItem.w*scale
          photo.height = varItem.h*scale
          photo.style.top = varItem.y*scale + "px"
          photo.style.left = varItem.x*scale + "px"
          break;
        }
      }
    },
    send(awardGrant) {
      let that = this
      this.sendModalVisible = true;
      this.currentAwardGrant = awardGrant
      let addrInfo = {}
      let sendAddress = this.currentAwardGrant.sendAddress
      let address = ''
      //如果证书上没有地址，则尝试从用户信息获取
      if(this.$store.getters.userInfo && this.$store.getters.userInfo.address){
        address = this.$store.getters.userInfo.address
        addrInfo.address = address
      }
      if(!sendAddress && this.$store.getters.userInfo && this.$store.getters.userInfo.expressAddress){
        sendAddress = this.$store.getters.userInfo.expressAddress
      }
      if(sendAddress){
        let lines = sendAddress.split('\n')
        for(let i=0;i<lines.length;i++){
          if(lines[i]==''){continue}
          let cols = lines[i].split(':')
          switch(cols[0]){
            case '收件人':
              addrInfo.name = cols[1]
              break;
            case '地区编码':
              addrInfo.address = cols[1]
              break;
            // case '地区':
            //   addrInfo.address = cols[1]
            //   break;
            case '地址':
              addrInfo.sendAddress = cols[1]
              break;
            case '手机号':
              addrInfo.phone = cols[1]
              break;
            case '备注':
              addrInfo.comment = cols[1]
              break;
          }
        }
      }
      console.log(addrInfo);
      that.$nextTick(() => {
        that.addressForm.setFieldsValue(
          pick(
            addrInfo,
            "sendAddress",
            "address",
            "name",
            "phone",
            "comment",
          )
        );
      });
    },
    handleSend() {
      // if(this.isEnsure(this.currentAwardGrant)){return}
      let that = this;
      this.addressForm.validateFields((err, values) => {
        console.log(values);
        let addrText = ""
        addrText +="收件人:" + values.name
        addrText +="\n手机号:" + values.phone
        addrText +="\n地区编码:" + values.address
        addrText +="\n地区:" + this.areaData.getTextRaw(values.address)
        addrText += "\n地址:" + values.sendAddress
        addrText +="\n备注:" + (values.comment?values.comment:'')
         getAction("/teaching/teachingAwardGrant/sendAward", {
          id: that.currentAwardGrant.id,
          address: values.address,
          sendAddress: addrText,
        })
        .then((res) => {
          if (res.success) {
            that.$info({
              title: "提示",
              content: res.message,
            });
            that.currentAwardGrant.sendAddress = addrText
          }else{
            that.$info({
              title: "提示",
              content: res.message,
            });
          }
        })
        .catch((e) => {
          that.checkIsLogin(e);
        });
      })
    },
    lost(awardGrant) {
      // if(this.isEnsure(awardGrant)){
      //   return
      // }
      if(!awardGrant.sendAddress){
        this.$info({
          title: "提示",
          content: "请先完成寄送地址填写",
        });
        return
      }
      if(awardGrant.sendAddress){
        this.endAddress = awardGrant.sendAddress
      }
      this.lossModalVisible = true;
      this.currentAwardGrant = awardGrant
    },
    handleLoss() {
      this.lossModalVisible = false
      let that = this;
      getAction("/teaching/teachingAwardGrant/lossAward", {
        id: this.currentAwardGrant.id,
        address: this.sendAddress,
      })
      .then((res) => {
        if (res.success) {
          alert("申请成功");
        }
      })
      .catch((e) => {
        that.checkIsLogin(e);
      });
    },
    handleScoreReport(item){
      // this.currentItem = item
      // this.scoreReportModalVisible=true
      window.open("/cert/studentReport?eventApplyId="+item.eventApplyId)
    },
    handleRejudge(item){
      let that = this
      if(item.scoreResult != '再接再厉'){
        this.$info({
          title: "提示",
          content: "成绩复核仅针对不合格学生，合格或优秀学生不接受复核申请，请谅解。公示期内复核申请回复学生各题型得分情况，不做具体解析，谢谢",
        });
        return
      }
      this.$refs.verifyCodeModal.show(function(){
        that.rejudgeModalVisible = true
        that.currentItem = item
        that.getScoreReport(item.userPaperId)
      })
    },
    rejudgeEmailSubmit(){
      var emailreg=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/
      if(!this.rejudgeEmail ||! emailreg.test(this.rejudgeEmail)){
        this.$message.info('请输入正确的邮箱')
      }
      getAction("/teaching/teachingRejudgeApply/apply", {
        eventApplyId: this.currentItem.eventApplyId,
        userPaperId: this.currentItem.userPaperId,
        email: this.rejudgeEmail
      }).then(res=>{
        this.$message.info(res.message)
      }).catch((e) => {
        this.checkIsLogin(e);
      });
    },
    rejudge() {
      let that = this;
      this.$confirm({
        title: "申请专家复议",
        content: <h3>您若申请专家人工介入复核，需扫码支付服务费50元，支付成功后，添加微信二维码，发送支付截图。5个工作内将回复复核结果。</h3>,
        onOk() {
          postAction("/teaching/teachingOrder/createOrder", {
            channel: "自动化学会",
            scene: "成绩复核",
            comment: "报名单ID:" + that.currentItem.eventApplyId,
            orderPrice: 5000,
          })
            .then((res) => {
              if (res.success) {
                that.$refs.payModal.bodyPrefix = "AICE复核";
                that.$refs.payModal.open(res.result);
                // that.rejudgePayOk = true
              }
            })
            .catch((e) => {
              that.checkIsLogin(e);
            });
        },
        onCancel() {},
        okText: "继续",
        cancelText: "关闭",
      });
    },
    payOk() {
      this.rejudgePayOk = true
    },
    isEnsure(awardGrant){
      if(awardGrant.awardEnsure == 1){
        this.$info({
          title: "提示",
          content: "请发邮件至zzc@aice.org.cn，写明修改原因及修改信息内容，并留下联系方式。",
        });
        return true
      }
      return false
    },
    checkIsLogin(e) {
      let that = this;
      console.log(e);
      console.log(e.response);
      if (
        e.response.status == 500 &&
        e.response.data.message.includes("Token失效")
      ) {
        this.$confirm({
          title: "未登录",
          content: "请先登录",
          okText: "去登录",
          onOk() {
            let route = that.$router.resolve({
              name: "login",
              query: {
                backUrl:
                  window.document.location.pathname +
                  window.document.location.search,
              },
            });
            window.open(route.href, "_blank");
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
body {
  margin: auto;
}

.header {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  /* position: fixed; */
  z-index: 1100;
  top: 0px;
  left: auto;
  right: 0px;
  height: 64px;
  background-color: rgb(25, 118, 210);
  color: rgb(255, 255, 255);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.header .title {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 0em;
  margin: 16px 50px;
  color: white;
}

.search-wrapper {
  max-width: 1000px;
  margin: 50px auto;
  text-align: center;
}

.cert-wrapper {
  max-width: 1200px;
  padding: 16px;
  border-width: 1px;
  border-style: dashed;
  border-image: initial;
  border-color: rgb(189, 189, 189);
  border-radius: 8px;
  margin: 40px auto;
}

.cert-wrapper img {
  max-width: 100%;
}


.cert-btn {
  display: inline-block;
  margin: 30px;
  width: 150px;
  height: 50px;
  text-align: center;
  line-height: 35px;
  font-size: 20px;
}
.table{
  width: 90%;
	background: #ccc;
	margin: 10px auto;
	border-collapse: collapse;
  th,td {
    height: 25px;
    line-height: 25px;
    text-align: center;
    border: 1px solid #ccc;
  }
  th {
    background: #eee;
    font-weight: normal;
  }
  tr {
    background: #fff;
  }
}
</style>